// extracted by mini-css-extract-plugin
export default {"guide-marker":"E+5iwzXQX3hVUSfo1lAHJA=="};